<template>
  <ServerSideResult :test="agents" style="width: 100%;">
    <v-data-table
      dense
      :headers="headers"
      :items="agents"
      item-key="id"
      class="elevation-1"
      @click:row="selectAgent"
    />
  </ServerSideResult>
</template>

<script>
import lookups from '@/mixins/lookups';
import ServerSideResult from "@/components/ServerSideResult";

export default {

  components: { ServerSideResult },

  data() {
    return {
      agents: undefined,
      headers: [
        { text: 'ID',   align: 'start', sortable: true, value: 'id'   },
        { text: 'Name', align: 'start', sortable: true, value: 'name' },
      ],
    }
  },

  methods: {
    selectAgent(agent) {
      this.$emit('agentSelected', agent);
    }
  },

  mounted() {
    this.remoteLookup('getFieldAgents', { depot: true }).then(agents => this.agents = agents).catch(e => this.agents = []);
  },

  mixins: [lookups],

}
</script>
